/* plugins/index.js */
//
import Vue from "vue";
//
import App from "@app";
//
import router from "@router";
//
import store from "@store";
// Axios
import axios from "axios";
// Element-UI
import ElementUI from "element-ui";
ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.DOCUMENT_NODE));
  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};
import "@assets/css/element-variables.scss";
// import "element-ui/lib/theme-chalk/index.css";
// View-UI
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
// Nprogress
import NProgress from "nprogress";
import "nprogress/nprogress.css";
// 拖拽排序
import Sortable from "sortablejs";
// vue-layer
import layer from "vue-layer";
import "vue-layer/lib/vue-layer.css";
// MD5 加密
import md5 from "js-md5";
// 加密工具
import { passwordMd5 } from "@/utils/md5";
//
import { Base_Url, Base_Api_Url, Base_Upload_Url } from "@config";
//
import { get, post } from "@utils/request/index";
// 自定义插件
import myPlugin from "./myPlugin.js";
// 方法插件
import method from "./method.js";

//
Vue.prototype.$layer = layer(Vue);

Vue.config.productionTip = false;

// 全局指令
import directive from "@/directive";

// 组件库
import Components from "@components";

// 组件渲染
Vue.use(ViewUI)
  .use(ElementUI)
  .use(myPlugin)
  .use(directive)
  .use(Components)
  .use(method);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export {
  Vue,
  store,
  axios,
  NProgress,
  Sortable,
  md5,
  passwordMd5,
  Base_Url,
  Base_Api_Url,
  Base_Upload_Url,
  get,
  post,
};
